import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../nodeInstance";
import { setAppError } from "../../../../store/userSlice";
import SecDepositecost from "./secDepositePopUp";

export default function EmployeeList({
  quotationType,
  quotationId,
  invoiceSummary,
  render,
  setRender,
  contract_id,
  setSummaryUpdate,
  summaryUpdate,
}) {
  console.log("contract_id.......print...", contract_id);
  const containerStyle = {
    display: "flex",
    width: "100%",
    margin: 0,
    padding: 0,
  };

  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");

  const row = [
    {
      id: 1,
      name: "YTC",
    },
  ];

  const name1Style = {
    width: "70%",
    // textAlign: 'center',
    // padding: "10px",
    boxSizing: "border-box",
  };

  const name2Style = {
    width: "30%",
    // textAlign: 'center',
    // padding: "10px",
    boxSizing: "border-box",
  };

  const tableHeading2_SUB = [
    {
      bgPrimary: "bg-pink-400",
      bgSecondary: "bg-pink-200",
    },
  ];
  const tableProperties2 = {
    colWidth: "w-28",
    colHeight: "h-[2.6rem]",
    itemHeight: "h-[3rem]",
  };

  const QuantityData = [
    {
      id: 1,
      Quantity: "YTC",
    },
  ];

  const tableHeading = [
    {
      rate_category_id: 1,
      title: "EMPLOYEE SALARY PACKAGE",
      bgPrimary: "bg-grey-400",
      bgSecondary: "bg-grey-200",
    },
  ];
  const tableProperties = {
    colWidth: "w-28",
    colHeight: "h-[3rem]",
    itemHeight: "h-[3rem]",
  };

  const tablePropertiestwo = {
    colWidth: "w-56",
    colHeight: "h-[3rem]",
    itemHeight: "h-[3rem]",
  };

  const dropDownData = [
    {
      name: "PENDING",
    },
    {
      name: "APPLICABLE",
    },
    {
      name: "INVOICE RAISED FULL",
    },
    {
      name: "INVOICE RAISED PARTIALLY",
    },
    {
      name: "PARTIAL PAYMENT RECEIVED",
    },
    {
      name: "FULL PAYMENT RECEIVED",
    },
  ];

  const [clProject, setClProject] = useState();

  const [employeeData, setEmployeeData] = useState();

  const clientAndProjectData = async () => {
    try {
      const data = await nodeinstance.get(
        `/dashboard/visaSecOnArrival/getDetailsByContract/${quotationId?.id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (data.status === 200) {
        console.log("Data to be seen here dfghjklouu...", data);
        setClProject(data?.data?.data);
      }
    } catch (error) {
      console.log("error to be seen here.....", error);
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };
  useEffect(() => {
    clientAndProjectData();
  }, [quotationId]);

  const employeeDataAPI = async () => {
    try {
      const response = await nodeinstance.get(
        `/dashboard/visaSecOnArrival/getEmpByProject/${clProject[0].project_id}/${contract_id.id}/${quotationType}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setEmployeeData(response?.data?.data);
        setSearch(response?.data?.data);
      }
    } catch (error) {
      console.log("employee data error to be displayed here...", error);
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      employeeDataAPI();
    }, 2000);
    return () => clearTimeout(timer);
  }, [clProject, summaryUpdate]);

  console.log("clProject............clProject", employeeData);

  const [search, setSearch] = useState();

  const [isSearch, setIsSearch] = useState(false);

  const filter = (e) => {
    const keyword = e.target.value;
    setIsSearch(true);
    if (keyword !== "") {
      const results = employeeData?.filter((user) => {
        const keysToSearch = [
          "employee_id",
          "name",
          "client",
          "visa_provider",
          "nationality",
          "passport_number",
          "visa_profession",
        ];

        return keysToSearch.some((key) =>
          user[key]?.toLowerCase().includes(keyword.toLowerCase())
        );
      });
      setSearch(results);
    } else {
      console.log("employeeData..........");
      setSearch(employeeData);
    }
  };
  const [selectedOption, setSelectedOption] = useState("");
  const [costplusBox, setCostPlusBox] = useState("");

  const handleCostplusBox = (value) => {
    setCostPlusBox(value);
  };

  const handleCheckboxChange = (value) => {
    if (value === "VISA COST") {
      setCostPlusBox("");
      setSelectedOption(value);
      return;
    }
    setSelectedOption(value);
  };
  const [downloadLoading, setDownloadLoading] = useState(false);
  const downloadTemplate = async () => {
    // setDownloadLoading(true);
    if (quotationType === "Hourly" || quotationType === "Monthly") {
      console.log("selectedOption..........SEC DEPOSIT ", costplusBox);
      // alert("mmmmmmmmmm.....");
      if (costplusBox === "") {
        dispatch(
          setAppError({
            msg: "Months required",
            // color: "success",
          })
        );
        return;
      }
      try {
        const response = await nodeinstance.get(
          `/dashboard/visaSecOnArrival/getEmpList/${clProject[0].project_id}/${contract_id.id}/${"SEC DEPOSIT"}/${costplusBox === "" ? 0 : costplusBox}`,
          {
            responseType: "blob",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 200) {
          const url = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Employee List`);
          document.body.appendChild(link);
          link.click();
          dispatch(
            setAppError({
              msg: "Excel Downloaded",
              color: "success",
            })
          );
          setDownloadLoading(false);
        }
      } catch (error) {
        console.log("error to be seen here....", error);
      }
      return;
    }
    try {
      if (selectedOption === "VISA COST") {
        try {
          const response = await nodeinstance.get(
            `/dashboard/visaSecOnArrival/getEmpList/${clProject[0].project_id}/${contract_id.id}/${selectedOption}/${costplusBox === "" ? 0 : costplusBox}`,
            {
              responseType: "blob",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.status === 200) {
            const url = window.URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Employee List`);
            document.body.appendChild(link);
            link.click();
            dispatch(
              setAppError({
                msg: "Excel Downloaded",
                color: "success",
              })
            );
            setDownloadLoading(false);
          }
        } catch (error) {
          console.log("error to be seen here....", error);
        }
        return;
      }
      if (
        costplusBox === null ||
        costplusBox === undefined ||
        costplusBox === ""
      ) {
        dispatch(
          setAppError({
            msg: "Months are required..",
          })
        );
        setDownloadLoading(false);
        return;
      }
      if (selectedOption === "") {
        dispatch(
          setAppError({
            msg: "Type is required..",
          })
        );
        setDownloadLoading(false);
        return;
      }
      const response = await nodeinstance.get(
        `/dashboard/visaSecOnArrival/getEmpList/${clProject[0].project_id}/${contract_id.id}/${selectedOption}/${costplusBox === "" ? 0 : costplusBox}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Employee List`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (error) {
      setDownloadLoading(false);
      console.log("error while downloading the template.....", error);
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };
  console.log("search.......search", search);

  const [showPromptElement, setShowPromptElement] = useState(false);

  const secPopUp = () => {
    setShowPromptElement(true);
  };

  const [visaStatus, setVisaStatus] = useState("");
  const [visaComments, setVisaComments] = useState("");
  const [secStatus, setSecStatus] = useState("");
  const [secComments, setSecComments] = useState("");
  console.log("Invoice summary......", invoiceSummary);
  useEffect(() => {
    setVisaStatus(
      invoiceSummary && invoiceSummary.data[0]?.invoice_for_visa_cost_status
    );
    setVisaComments(invoiceSummary && invoiceSummary.data[0]?.finance_comments);
    setSecStatus(
      invoiceSummary &&
        invoiceSummary.data[0]?.invoice_for_security_deposit_status
    );
    setSecComments(
      invoiceSummary && invoiceSummary.data[0]?.comments_for_finance
    );
  }, [invoiceSummary, render]);

  const visaStatusChange = (e) => {
    setVisaStatus(e.target.value);
  };
  const visaCommentsChange = (e) => {
    setVisaComments(e.target.value);
  };
  const secStatusChange = (e) => {
    setSecStatus(e.target.value);
  };

  const secCommentsChange = (e) => {
    setSecComments(e.target.value);
  };
  console.log("Data to be printed here.......", secComments);
  const onDropSubmit = async () => {
    try {
      const reqObject = {
        invoice_for_security_deposit_status: secStatus,
        finance_comments: secComments,
        invoice_for_visa_cost_status: visaStatus,
        comments_for_finance: visaComments,
        visa_sec_deposit_status: "YES",
      };
      const response = await nodeinstance.put(
        `/dashboard/visaSecOnArrival/addSummary/${contract_id.id}`,
        reqObject,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        dispatch(
          setAppError({
            msg: "Updated successfully.",
            color: "success",
          })
        );
        setRender(!render);
      }
    } catch (error) {
      console.log("error to be displayed here.....", error);
      dispatch(
        setAppError({
          msg: "Failed to update the details",
        })
      );
    }
  };
  console.log("clProject........clProject....", clProject);
  return (
    <>
      <div className="ml-4 flex flex-wrap items-center">
        <div className="mr-4">
          <h2>CLIENT NAME: {clProject && clProject[0].client}</h2>
          <h2>PROJECT NAME: {clProject && clProject[0].project}</h2>
          <h2>EMPLOYEE COUNT: {search && search?.length}</h2>
        </div>
        {quotationType === "Cost Plus" ? (
          <>
            <div className="flex items-center mr-4">
              <input
                className="ml-2"
                type="checkbox"
                checked={selectedOption === "VISA COST"}
                onChange={() => handleCheckboxChange("VISA COST")}
              />
              <span className="ml-2">VISA COST</span>
            </div>

            <div className="flex items-center mr-4">
              <input
                type="checkbox"
                checked={selectedOption === "SEC DEPOSIT"}
                onChange={() => handleCheckboxChange("SEC DEPOSIT")}
              />
              <span className="ml-2">SEC DEPOSIT</span>
            </div>
          </>
        ) : (
          ""
        )}
        <div
          className={`mr-4 flex ${quotationType === "Hourly" || quotationType === "Monthly" ? "flex-row gap-x-4" : "flex-col gap-y-4"}`}
        >
          <div className="flex items-center">
            <input
              type="checkbox"
              checked={costplusBox === "1"}
              onChange={() => handleCostplusBox("1")}
              disabled={selectedOption === "VISA COST"}
            />
            <span className="ml-2">1 MONTH</span>
          </div>

          <div
            className={`${quotationType === "Hourly" || quotationType === "Monthly" ? "flex items-center" : "flex items-center mt-2"}`}
          >
            <input
              type="checkbox"
              checked={costplusBox === "2"}
              onChange={() => handleCostplusBox("2")}
              disabled={selectedOption === "VISA COST"}
            />
            <span className="ml-2">2 MONTHS</span>
          </div>
        </div>

        <label className="mr-6">
          <input
            type="search"
            className="input input-sm h-10 max-w-xs pl-2 input-bordered focus:outline-none uppercase text-sm p-3"
            placeholder={"Search Employee"}
            onChange={filter}
          />
        </label>

        <label className="mr-6">
          <button
            className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white"
            disabled={downloadLoading}
            onClick={downloadTemplate}
          >
            DOWNLOAD LIST
          </button>
        </label>

        <label className="mr-6 ml-2">
          <button
            className="w-48 h-13 p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white text-sm"
            style = {{textAlign : "center"}}
            onClick={secPopUp}
          >
            UPLOAD & GENERATE PROFORMA INVOICE
          </button>
        </label>
      </div>

      <div style={containerStyle} className="!uppercase">
        <div style={name1Style}>
          <div
            className="flex flex-col w-full gap-1 my-2 overflow-x-scroll pt-4"
            style={employeeData?.length > 4 ? { height: "210px" } : {}}
          >
            <div className="flex">
              {row.map((section, sectionIndex) => (
                <div className="flex flex-col relative" key={sectionIndex}>
                  {sectionIndex == 0 && (
                    <>
                      <div className={`flex w-full gap-1 `}>
                        <>
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                          >
                            SL. NO.
                          </p>
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                          >
                            EMP ID
                          </p>
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                          >
                            EMP NAME
                          </p>
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                          >
                            CLIENT
                          </p>
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tablePropertiestwo.colWidth} ${tablePropertiestwo.colHeight}`}
                          >
                            VISA PROVIDER
                          </p>
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tablePropertiestwo.colWidth} ${tablePropertiestwo.colHeight}`}
                          >
                            NATIONALITY
                          </p>
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tablePropertiestwo.colWidth} ${tablePropertiestwo.colHeight}`}
                          >
                            PASSPORT NUMBER
                          </p>
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tablePropertiestwo.colWidth} ${tablePropertiestwo.colHeight}`}
                          >
                            VISA PROFESSION
                          </p>
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tablePropertiestwo.colWidth} ${tablePropertiestwo.colHeight}`}
                          >
                            ACTUAL PROFESSION
                          </p>
                          {quotationType === "Cost Plus" ? (
                            <p
                              className={`bg-slate-200 flex items-center justify-center ${tablePropertiestwo.colWidth} ${tablePropertiestwo.colHeight}`}
                            >
                              VISA COST
                            </p>
                          ) : (
                            ""
                          )}
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tablePropertiestwo.colWidth} ${tablePropertiestwo.colHeight}`}
                          >
                            SECURITY DEPOSITE COST
                          </p>
                        </>
                      </div>
                    </>
                  )}
                  <div className="mb-2">
                    {search?.map((data, index) => (
                      <div
                        className="flex w-full gap-1 relative mb-2 mt-2"
                        key={index}
                      >
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {index + 1}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {data.employee_id}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {data.name}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {data.client}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tablePropertiestwo.colWidth} ${tablePropertiestwo.colHeight}`}
                        >
                          {data.visa_provider}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tablePropertiestwo.colWidth} ${tablePropertiestwo.colHeight}`}
                        >
                          {data.nationality}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tablePropertiestwo.colWidth} ${tablePropertiestwo.colHeight}`}
                        >
                          {data.passport_number}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tablePropertiestwo.colWidth} ${tablePropertiestwo.colHeight}`}
                        >
                          {data.visa_profession}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tablePropertiestwo.colWidth} ${tablePropertiestwo.colHeight}`}
                        >
                          {data.actual_profession}
                        </p>
                        {quotationType === "Cost Plus" ? (
                          <p
                            className={`flex items-center justify-center ${tablePropertiestwo.colWidth} ${tablePropertiestwo.colHeight}
                            ${data.visa_cost_payment_status === "RAISED" ? "bg-green-500" : "bg-slate-200"}`}
                          >
                            {data.visa_cost_payment_status === "RAISED"
                              ? 2000
                              : "YET TO RAISE VISA COST"}
                          </p>
                        ) : (
                          ""
                        )}
                        {/* <p
                          className={`bg-slate-200 flex items-center justify-center ${tablePropertiestwo.colWidth} ${tablePropertiestwo.colHeight}`}
                        >
                          {data.sec_deposit_cost === null
                            ? "YET TO RAISE SEC DEPOSITE"
                            : data.sec_deposit_cost}
                        </p> */}
                        <p
                          className={`flex items-center justify-center ${tablePropertiestwo.colWidth} ${tablePropertiestwo.colHeight} 
                           ${data.security_deposit_payment_status === "RAISED" ? "bg-green-500" : "bg-slate-200"}`}
                        >
                          {data.security_deposit_payment_status != "RAISED"
                            ? "YET TO RAISE SEC DEPOSITE"
                            : data.sec_deposit_cost}
                        </p>
                      </div>
                    ))}
                  </div>
                  <div className="mb-2"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div style={name1Style} className="flex flex-col w-full gap-2 pl-10">
          <div style={{ display: "flex" }}>
            <div style={{ width: "40%" }} className="ml-5">
              {/* {quotationType === "Cost Plus" && ( */}
              <>
                <div className="flex flex-col gap-1 w-full max-w-md">
                  <label htmlFor={`addOrEdit-name`} className="text-xs">
                    VISA COST STATUS
                  </label>
                  <select
                    className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-3 text-md"
                    value={visaStatus}
                    onChange={visaStatusChange}
                  >
                    <option>{"select value"}</option>
                    {dropDownData?.map((data, index) => (
                      <React.Fragment key={index}>
                        <option value={data.name}>{data.name}</option>
                      </React.Fragment>
                    ))}
                  </select>
                </div>
              </>
              {/* )} */}

              <div className="flex flex-col gap-1 w-full max-w-md mt-4">
                <label htmlFor={`addOrEdit-name`} className="text-xs">
                  SEC. DEPOSIT STATUS
                </label>
                <select
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-3 text-md"
                  value={secStatus}
                  onChange={secStatusChange}
                >
                  <option>{"select value"}</option>
                  {dropDownData?.map((data, index) => (
                    <React.Fragment key={index}>
                      <option value={data.name}>{data.name}</option>
                    </React.Fragment>
                  ))}
                </select>
              </div>
            </div>

            {/* Second column with large text box */}
            <div style={{ width: "40%" }} className="ml-3">
              <div className="flex flex-col gap-1 w-full max-w-md">
                <label htmlFor={`additional-comments`} className="text-xs">
                  Comments for Finance
                </label>
                <textarea
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-11 text-md"
                  placeholder="Enter your comments here"
                  value={secComments}
                  onChange={secCommentsChange}
                />
              </div>
            </div>
          </div>

          {/* Last Text Box covering the length and coming on top of Submit */}
          <div className="flex flex-col gap-1 w-full max-w-md mt-1 ml-4">
            <label htmlFor={`additional-comments`} className="text-xs">
              Comments By Finance
            </label>
            <textarea
              className="border-[1px] border-border dark:bg-dark rounded-md py-5 text-md"
              placeholder="Enter your comments here"
              style={{ width: "95%" }} // Make it cover the full width
              disabled
              value={visaComments}
            />
          </div>

          {/* Submit button */}
          <div className="mt-4">
            <button
              className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-xs ml-10"
              onClick={() => {
                onDropSubmit();
              }}
            >
              Submit
            </button>
          </div>
        </div>
      </div>

      {showPromptElement ? (
        <SecDepositecost
          showPromptElement={showPromptElement}
          setShowPromptElement={setShowPromptElement}
          setSummaryUpdate={setSummaryUpdate}
          summaryUpdate={summaryUpdate}
          clProject={clProject}
        />
      ) : (
        ""
      )}
    </>
  );
}
